import React, { useMemo } from "react";
import { CircularProgress } from "@mui/material";
import { resolveFullName, getStatusConfig, formatDateTime } from "./TaskDetailsModal";

/* ── ActivityTimelineEvent ──────────────────────────────────────────────── */

export const ActivityTimelineEvent = React.memo(({ event, idx }) => {
  const eventUser = event.user || {};
  const userName = useMemo(
    () => resolveFullName(eventUser.first_name, eventUser.last_name) || "System",
    [eventUser.first_name, eventUser.last_name]
  );
  const eventStatus = useMemo(() => getStatusConfig(event.action), [event.action]);

  return (
    <div className="tdm-timeline-item">
      <span
        className="tdm-timeline-dot"
        style={{ background: eventStatus.dot }}
      />
      <div className="tdm-timeline-content">
        <div className="tdm-timeline-row">
          <span className="tdm-timeline-status" style={{ color: eventStatus.text }}>{event.action}</span>
          <span className="tdm-timeline-by">by {userName}</span>
        </div>
        {event.remarks && <p className="tdm-timeline-remark">{event.remarks}</p>}
        <span className="tdm-timeline-date">{formatDateTime(event.created_at)}</span>
        {event.attachments?.length > 0 && (
          <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {event.attachments.map((att) => (
              <div
                key={att.id}
                style={{
                  fontSize: "0.7rem",
                  padding: "2px 8px",
                  background: "#f3f4f6",
                  borderRadius: "4px",
                  border: "1px solid #e5e7eb",
                  color: "#374151",
                }}
              >
                📎 {att.original_name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});
ActivityTimelineEvent.displayName = "ActivityTimelineEvent";

/* ── ActivityTimelinePanel ──────────────────────────────────────────────── */

const ActivityTimelinePanel = React.memo(({ timeline, loadingTimeline }) => {
  if (loadingTimeline) {
    return <div className="tdm-loading"><CircularProgress size={22} /></div>;
  }
  if (!timeline || timeline.length === 0) {
    return <p className="tdm-empty">No activity recorded for this task.</p>;
  }
  return (
    <div className="tdm-timeline-list">
      {timeline.map((event, idx) => (
        <ActivityTimelineEvent key={event.id || idx} event={event} idx={idx} />
      ))}
    </div>
  );
});
ActivityTimelinePanel.displayName = "ActivityTimelinePanel";

export default ActivityTimelinePanel;
